import { twJoin, twMerge } from 'tailwind-merge';

import * as StoreCard from '@/components/Store/StoreCard';

export type StoresGridProps = {
  stores?: AdaptedStore[];
  isCardHorizontal?: boolean;
  className?: string;
};

export function StoresGrid({
  stores,
  isCardHorizontal = false,
  className,
}: StoresGridProps) {
  return (
    <div
      data-horizontal={isCardHorizontal}
      className={twMerge(
        'mt-20 grid w-full grid-cols-1 items-center justify-items-center sm:grid-cols-2 lg:grid-cols-4',
        'data-[horizontal=true]:sm:grid-cols-1 data-[horizontal=true]:lg:grid-cols-1',
        'gap-12 lg:gap-x-10 lg:gap-y-20',
        'data-[horizontal=true]:mt-8 data-[horizontal=true]:lg:gap-y-4',
        className,
      )}
    >
      {stores?.map(store => {
        return (
          <StoreCard.Root
            key={store.id}
            data-horizontal={isCardHorizontal}
            store={store}
            className={twJoin(
              'group w-full max-w-xs data-[horizontal=true]:max-w-full',
              'data-[horizontal=true]:flex-row data-[horizontal=true]:items-center',
              'data-[horizontal=true]:gap-4 data-[horizontal=true]:p-0 sm:data-[horizontal=true]:gap-6',
            )}
          >
            <StoreCard.TitleImage
              className={twJoin(
                'group-data-[horizontal=true]:m-0 group-data-[horizontal=true]:max-w-48 group-data-[horizontal=true]:rounded-lg',
                'group-data-[horizontal=true]:w-full group-data-[horizontal=true]:min-w-3/12',
              )}
            />

            <StoreCard.Content
              className={twJoin(
                'group-data-[horizontal=true]:w-full',
                'group-data-[horizontal=true]:p-0 group-data-[horizontal=true]:pr-2.5',
                'lg:group-data-[horizontal=true]:py-3',
                'overflow-hidden text-xs sm:text-base',
              )}
            >
              <StoreCard.Info>
                <StoreCard.Name />

                <StoreCard.Street className="text-sm" />

                <StoreCard.Address className="text-sm" />
              </StoreCard.Info>

              <StoreCard.CategoryIcon />
            </StoreCard.Content>
          </StoreCard.Root>
        );
      })}
    </div>
  );
}
